import { make } from 'vuex-pathify';

import api from '@/services/api';

const state = {
  newFeatureGeometry: undefined,
  isAddingButtonActive: false,
  isEditingButtonActive: false,
  isCopyButtonActive: false,
  isSplittingLineButtonActive: false,
  isAssignParcelButtonActive: false,
  copiedObject: false,
  tableSelectionType: undefined,
  isDrawingInteractionActive: false,
  isModificationInteractionActive: false,
  isModifySnappingActive: false,
  globalFilters: undefined,
};

const mutations = make.mutations(state);

const actions = {
  async calculateFields(state, { calculator_expressions, features_filter, dataSource }) {
    const r = await api.post(`/dataio/data_sources/${dataSource}/field_calculator`, {
      calculator_expressions,
      features_filter,
    });
    return r.data.data;
  },
  async calculateFieldsTopo(state, { calculator_expressions, features_filter, dataSource }) {
    const r = await api.post(`/topological_edit/${dataSource}/field_calculator`, {
      calculator_expressions,
      features_filter,
    });
    return r.data.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
